<template>
  <v-layout column>
    <v-toolbar dense flat style="padding-left: 0; background: none">
      <v-toolbar-title class="pl-1 body-1">{{label}}</v-toolbar-title>
      <v-dialog
        v-model="dialog"
        persistent
        scrollable
        width="650"
      >
        <v-btn flat icon color="primary" slot="activator" @click="()=>{item={};user={}; editIdx = null}">
          <v-icon>add</v-icon>
        </v-btn>
        <v-card>
          <v-card-text>
            <v-form v-model="formValid" ref="formRef" >
              <v-container>
                <v-layout row wrap>

                  <v-flex xs8>
                    <x-user-select
                      :multiple="false"
                      label="参与人"
                      :rules="rules.required"
                      v-model="user"
                    />
                  </v-flex>

                  <v-flex xs4>
                    <v-select
                      label="参与人排名"
                      :rules="rules.required"
                      :items="rankValidItems"
                      v-model="item.order"
                    />
                  </v-flex>
                  <v-flex xs3>
                    <v-select
                      label="参与人类型"
                      item-text="name"
                      item-value="dbid"
                      :rules="rules.required"
                      :items="[{dbid:'yjs',name:'研究生'},{dbid:'js',name:'教师'},{dbid:'bks',name:'本科生'},{dbid:'xw',name:'校外'}]"
                      v-model="item.personType"
                      persistent-hint
                    ></v-select>
                  </v-flex>
                  <v-flex xs9 v-if="item.personType!='xw'">
                    <v-autocomplete
                      label="归属部门"
                      clearable
                      :rules="rules.required"
                      v-model="item.deptId"
                      @change = "nv => item.deptName = deptItems.find(v => v.dbid === nv).name"
                      item-text="name"
                      item-value="dbid"
                      :items="deptItems"
                    />
                  </v-flex>

                  <v-flex xs4 v-if="item.personType!='xw'">
                    <v-text-field label="合同号/学号" required :rules="rules.appNo" v-model="item.appNo"/>
                  </v-flex>
                  <v-flex xs4 v-if="item.personType!='xw'">
                    <v-select
                      label="参与类别"
                      item-text="name"
                      item-value="dbid"
                      :rules="rules.required"
                      :items="[{dbid:'ptr',name:'普通参与人'},{dbid:'lxr',name:'联系人'},{dbid:'fzr',name:'负责人'}]"
                      v-model="item.contactsType"
                      persistent-hint
                    ></v-select>
                  </v-flex>
                  <v-flex xs4 v-if="item.contactsType !== 'ptr'&& item.personType!='xw'">
                    <v-text-field label="手机" required :rules="rules.contactsPhone" v-model="item.contactsPhone"/>
                  </v-flex>
                  <v-flex xs4 v-if="item.contactsType !== 'ptr'&& item.personType!='xw'">
                    <v-text-field label="电子邮箱" required :rules="rules.contactsEmail" v-model="item.contactsEmail"/>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="dialog = false">取消</v-btn>
            <v-btn color="primary" @click.native="onOk">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      class="dense"
      :headers="headers"
      :items="value"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{props.item.order}}</td>
        <td>{{props.item.name}}<br>{{props.item.appNo}}</td>
        <td>{{userTypeMap[props.item.personType]}}</td>
        <td>{{props.item.deptName}}</td>
        <td>{{stateMap[props.item.contactsType]}}</td>
        <td>{{props.item.contactsPhone}}<br>{{props.item.contactsEmail}}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="onEdit(props.index, props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="onDel(props.index)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
  import XUserSelect from '@/components/global/UserSelectForm'
  const deptUri = '/api/syst/department';
  export default {
    name: 'appPerson',
    props: ['value', 'label', 'hint'],
    components: {XUserSelect},

    data() {
      return {
        headers: [
          {text: '排序', sortable: false, value: 'rank', width: 18},
          {text: '姓名,合同号/学号', align: 'left', sortable: false, value: 'name'},
          {text: '参与人类型', align: 'left', sortable: false, value: 'personType'},
          {text: '归属部门', align: 'left', sortable: false, value: 'deptName'},
          {text: '参与类别', align: 'left', sortable: false, value: 'contactsType'},
          {text: '手机/电子邮箱', align: 'left', sortable: false, value: 'contactsPhone'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid'}
        ],
        stateMap: {
          lxr: "联系人",
          ptr: "普通申请人",
          fzr: "负责人"
        },
        userTypeMap: {
          yjs:"研究生",
          js:"教师",
          bks:"本科生",
          xw:"校外"
        },
        /**
         * 验证规则
         */
        rules: {
          appNo: [
            v => !!v || '必填项。'
          ],
          required: [
            v => !!v || '必填项。'
          ],
          contactsPhone: [
            v => !!v || '必填项。',
            v => (v && v.length < 12) || "长度不能超过11个字符。",
            v => (v && /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/ig.test(v)) || '电话号码格式不正确。'
          ],
          contactsEmail:  [
            v => !!v || '必填项。',
            v => /^\w+@\w+\.\w+$/ig.test(v) || "邮箱地址格式不正确。",
            v => (v && v.length < 50) || "长度不能超过 50 个字符。"
          ]
        },
        deptItems: [],
        dialog: false,
        item: {
          dbid: null,
          intelId: null,
          userId: null,
          name: null,
          order: null,
          deptId: null,
          deptName: null,
          personType: null,
          appNo: null,
          contactsType: null,
          contactsPhone: null,
          contactsEmail: null
        },
        user: {
          userId: null,
          name: null,
          deptId: null,
          deptName: null,
          number: null
        },
        editIdx: null,
        formValid: false,
        rankItems: [1, 2, 3, 4, 5, 6, 7, 8, 9,10,11,12,13,14,15,16,17,18,19,20]

      }
    },
    created() {
      // 加载审核状态
      this.axios.all([
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
      ]).then(
        this.axios.spread(
          (rspDept) => {
            this.deptItems = rspDept.data.items;
          }
        )
      )
    },
    watch: {
      user: function (u) {
        Object.assign(this.item, u);
        this.item.deptId = u.deptId;
        this.item.deptName = u.deptName;
        this.item.appNo = u.number;
      },
    },
    computed: {
      rankValidItems() {
        const invalid = (this.value || []).map(v => v.order).filter (v => v !== this.item.order);
        return this.rankItems.filter((v, i, a) => !invalid.includes(v));
      }
    },
    methods: {
      onEdit(idx, it) {
        this.editIdx = idx;
        this.item = window.xutil.clone(it);
        this.user.userId = this.item.userId;
        this.user.name = this.item.name;
        this.user.deptName = this.item.deptName;
        this.user.deptId = this.item.deptId;
        this.user.number  = this.item.appNo;
        this.dialog = true;
      },
      onOk() {
        if (this.$refs.formRef.validate()) {
          let apps = window.xutil.clone(this.value);

          if (this.editIdx != null) {
            apps[this.editIdx] = window.xutil.clone(this.item);
          } else {
            apps.push(xutil.clone(this.item));
          }

          apps.sort((a, b) => a.rank - b.rank);
          this.$emit('input', apps);
          this.dialog = false;
        }
      },
      onDel(idx) {
        this.$emit('input', this.value.filter((v, i) => i !== idx))
      }
    }
  }
</script>
<style>
  div.menu__content.hide-list {
    display: none;
  }
</style>

